<div class="modal-header">
  <div class="modal-title">
    <i class="bi bi-exclamation-triangle archive-icon"></i>
    <div>
      <h3 class="mb-0">Archive vendor</h3>
      <p class="modal-subtitle mb-0">{{ subtitle }}</p>
    </div>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close('Cross Click')"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="noteForm">
    <div class="form-group">
      <label for="title" class="form-label" requiredAsterisk>Title</label>
      <input
        id="title"
        type="text"
        class="form-control"
        formControlName="title"
        placeholder="Short summary of the archive reason"
      />
    </div>

    <div class="form-group mb-0">
      <label for="note" class="form-label" requiredAsterisk>Note</label>
      <textarea
        id="note"
        class="form-control archive-note"
        [rows]="5"
        formControlName="note"
        [placeholder]="notePlaceholder"
      ></textarea>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close('Close')">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirm()">
      Archive vendor
    </button>
  </div>
</div>
